export enum ActionType {
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  EXECUTE = 'EXECUTE',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  PASSWORD_RESET = 'PASSWORD_RESET'
}

export enum ActionDomain {
  GLOBAL_SETTINGS = 'GLOBAL_SETTINGS',
  SETTINGS = 'SETTINGS',
  SCHEDULING_PROJECT = 'SCHEDULING_PROJECT',
  SCHEDULING_PROJECT_TEMPLATE = 'SCHEDULING_PROJECT_TEMPLATE'
}

export enum ActionStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export enum HolderType {
  Member = 'Member',
  ServiceAccount = 'ServiceAccount',
  Agent = 'Agent',
  Shipper = 'Shipper',
  Customer = 'Customer',
  User = 'User'
}

export const ACTION_TYPES = Object.values(ActionType);
export const ACTION_DOMAINS = Object.values(ActionDomain);
export const ACTION_STATUSES = Object.values(ActionStatus);
export const HOLDER_TYPES = Object.values(HolderType);

export const ACTION_TYPE_FILTER_OPTIONS = ['ALL', ...ACTION_TYPES];
export const STATUS_FILTER_OPTIONS = ['ALL', ...ACTION_STATUSES];
